import initialState from './initialState'

const FETCH_MENU_PAGES = 'md/features/Pages/FETCH_MENU_PAGES'
const FETCH_MENU_PAGES_SUCCESS = 'md/features/Pages/FETCH_MENU_PAGES_SUCCESS'
const FETCH_MENU_PAGES_FAILED = 'md/features/Pages/FETCH_MENU_PAGES_FAILED'

const FETCH_PAGE_BY_SLUG = 'md/features/Pages/FETCH_PAGE_BY_SLUG'
const FETCH_PAGE_BY_SLUG_SUCCESS = 'md/features/Pages/FETCH_PAGE_BY_SLUG_SUCCESS'
const FETCH_PAGE_BY_SLUG_FAILED = 'md/features/Pages/FETCH_PAGE_BY_SLUG_FAILED'

const CLEAR_CURRENT_PAGE = 'md/features/Pages/CLEAR_CURRENT_PAGE'

// Actions
export const fetchMenuPages = (languageCode = 'sv', tag = 'meny') => {
  const payload = {
    languageCode,
    tag
  }

  return {
    types: [FETCH_MENU_PAGES, FETCH_MENU_PAGES_SUCCESS, FETCH_MENU_PAGES_FAILED],
    callApi: {
      endpoint: 'api/Pages',
      method: 'GET',
      data: payload
    }
  }
}

export const fetchPageBySlug = (slug, languageCode = 'sv') => {
  const payload = {
    languageCode
  }

  return {
    types: [FETCH_PAGE_BY_SLUG, FETCH_PAGE_BY_SLUG_SUCCESS, FETCH_PAGE_BY_SLUG_FAILED],
    callApi: {
      endpoint: `api/Pages/${slug}`,
      method: 'GET',
      data: payload
    }
  }
}

export const clearCurrentPage = () => {
  return {
    type: CLEAR_CURRENT_PAGE
  }
}

// Reducer
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_MENU_PAGES:
      return {
        ...state,
        loading: true,
        error: null
      }
    case FETCH_MENU_PAGES_SUCCESS:
      return {
        ...state,
        menuPages: action.data || [],
        loading: false
      }
    case FETCH_MENU_PAGES_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error
      }
    case FETCH_PAGE_BY_SLUG:
      return {
        ...state,
        loading: true,
        error: null
      }
    case FETCH_PAGE_BY_SLUG_SUCCESS:
      return {
        ...state,
        currentPage: action.data,
        loading: false
      }
    case FETCH_PAGE_BY_SLUG_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
        currentPage: null
      }
    case CLEAR_CURRENT_PAGE:
      return {
        ...state,
        currentPage: null
      }
    default:
      return state
  }
}
